const FinBankCreditScoreDashboardI18n = {
  tabs: {
    scoreResult: 'Resultado Score',
    scoreInfo: 'Informações Gerais',
  },
  loading: {
    fetchingScore: 'Carregando dados do score...',
  },
  fetchError: 'Não foi possível carregar os dados do score. Tente novamente em instantes.',
  error: {
    title: 'Erro',
    missingDocument: 'A propriedade "document" é obrigatória para consultar o score.',
    missingAuthCredentials: 'Informe "tokenProvider" ou "integratorToken" para autenticar o componente.',
  },
  refreshDialog: {
    cancel: 'Cancelar',
    confirm: 'Atualizar informações',
    withinLimit: {
      title: 'Importante!',
      message: 'A atualização destas informações gerará uma nova consulta com o parceiro de crédito, que contará nas transações do seu plano.<br/><br/>Deseja continuar?',
    },
    limitReached: {
      title: 'Atenção',
      message: 'O pacote de consultas contratadas já acabou, se prosseguir, será gerado uma cobrança de consulta excedente.<br/><br/>Deseja continuar?',
    },
  },
};

export default FinBankCreditScoreDashboardI18n;
